
    <div class="login-card">
        <div class="login-header">
            <img src="../assets/traton-logo.jpg" alt="TRATON Logo" class="login-logo" />
        </div>
        <div class="login-body">
            <p class="login-instruction">Sign in with your corporate ID</p>
            <div class="brand-buttons">
                <button class="brand-btn" (click)="login('Scania')">
                    SCANIA
                </button>
                <button class="brand-btn" (click)="login('ScaniaCn')">
                    SCANIACN
                </button>
                <button class="brand-btn" (click)="login('International')">
                    INTERNATIONAL
                </button>
            </div> 
        </div> 
    </div>
